export default __webpack_public_path__ + "static/media/location-icon.d99cb9d4.svg";